import type { Plan } from '../../../types/subscription';
import { PricingCard } from './PricingCard';

interface SubscriptionCardsProps {
  plans: Plan[];
  onCheckout: (priceId: string, cancelUrl: string, name: string) => void;
  subPriceId?: string;
  subsPlanName?: string;
  isAuthenticated: boolean;
  link?: string;
  freeSubsName: string;
  isLoading: boolean;
  isCurrentUserAdmin?: boolean;
}

export function SubscriptionCards({
  plans,
  onCheckout,
  subPriceId,
  subsPlanName,
  isAuthenticated,
  link,
  freeSubsName,
  isLoading,
  isCurrentUserAdmin,
}: SubscriptionCardsProps) {
  return (
    <>
      {plans.map((plan) => (
        <PricingCard
          key={plan.name}
          {...plan}
          onCheckout={onCheckout}
          subPriceId={subPriceId}
          subsPlanName={subsPlanName}
          isAuthenticated={isAuthenticated}
          link={link}
          freeSubsName={freeSubsName}
          isLoading={isLoading}
          isCurrentUserAdmin={isCurrentUserAdmin}
        />
      ))}
    </>
  );
}
